const caseCategory = () => import('@/pages/case/category/index.vue');

export default [{
    path: '/case/category',
    component: caseCategory,
    meta: [{
        name: '案例管理',
		activeRoute: '/case/manage'
    },
    {
        name: '案例分类',
        activeRoute: '/case/category'
    }]
}];